import { useCallback } from 'react';
import type { GoodsDiscountGroupItem } from 'shared/src/api';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';

export const useLogClickCheckBox = (item: GoodsDiscountGroupItem) => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  return useCallback(
    (isOn: boolean) => {
      logGoodsAnalytics({
        name: 'CLICK_CHECKBOX',
        analytics: {
          IS_ON: isOn ? '1' : '0',
          ...item.logging.analytics,
          SCREEN: 'GOODS_DETAIL',
        },
      });
    },
    [item.logging.analytics, logGoodsAnalytics],
  );
};
